// Helper function to sort an array by a specific field
// Accepts an array, a field to sort by, and an optional order in ascending or descending order
export function sortArrayByField<T>(
  array: T[],
  field: string,
  order: 'asc' | 'desc' = 'asc'
): T[] {
  return array.sort((a, b) => {
    const valueA = getNestedValue(a, field);
    const valueB = getNestedValue(b, field);

    if (
      (valueA instanceof Date || typeof valueA === 'string') &&
      (valueB instanceof Date || typeof valueB === 'string')
    ) {
      const dateA = new Date(valueA).getTime();
      const dateB = new Date(valueB).getTime();

      return order === 'asc' ? dateA - dateB : dateB - dateA;
    }

    return order === 'asc'
      ? (valueA as any) - (valueB as any)
      : (valueB as any) - (valueA as any);
  });
}
// Helper function to retrieve nested values safely
function getNestedValue(obj: any, keyPath: string): any {
  return keyPath.split('.').reduce((acc, key) => acc?.[key], obj);
}
